import API from '../api/api';
import { ApiRoutes } from '../constans/api';

export interface IOrganizations {
  id: string;
  name: string;
  allowed_surveys: string[];
}

export interface ProjectEntity {
  id: number;
  name: string;
  type: string;
}

export interface IGetOrganizationsResp {
  items: IOrganizations[];
}

export const getOrganizationsRequest = async (): Promise<IGetOrganizationsResp> => {
  const { organizations } = ApiRoutes;
  const { data } = await API.get(organizations);
  return data;
};

export const getProjectsRequest = async (organizationId: number): Promise<ProjectEntity[]> => {
  const { organizations, projects } = ApiRoutes;
  const { data } = await API.get(`${organizations}${organizationId}${projects}`);
  return data;
};
